import { useRef, useEffect } from 'react';
import { GeogebraComponent } from '@apps/geogebra';
import { useComponentFrameworkAutoDeactivation } from '@provider/component-framework';
import { useLocation } from '@provider/navigation';
import { contentTransitionDurationMs } from './comp.router.style.js';
import { jsx } from 'react/jsx-runtime';

function EmbedContent(props) {
  const isTransitioningBetweenPagesRef = useTransitionState();
  useComponentFrameworkAutoDeactivation(props.rootRef, {
    componentId: props.node.component.envelope.ID,
    isDisabledRef: isTransitioningBetweenPagesRef,
    onDeactivate: props.onDeactivate
  });
  return /*#__PURE__*/jsx(GeogebraComponent, {
    context: "embedded",
    onShareWithTeacher: props.onShareWithTeacher,
    onCollapse: props.onCollapse,
    onActivate: props.onActivate,
    onResetEntry: props.onResetEntry,
    component: props.node.component,
    node: props.node
  });
}
function useTransitionState() {
  const location = useLocation();
  const isTransitioningRef = useRef(false);
  useEffect(() => {
    isTransitioningRef.current = true;
    const timeoutId = setTimeout(() => {
      isTransitioningRef.current = false;
    }, contentTransitionDurationMs);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.asPath]);
  return isTransitioningRef;
}

export { EmbedContent };
//# sourceMappingURL=comp.embed-integration.js.map
